import React, { ReactElement } from 'react';
import Location from '../../../design-system/Location';
import Phone from '../../../design-system/Phone';
import Mail from '../../../design-system/Mail';
import Map from '../../Map';

const Contact: React.FC = (): ReactElement => {
  return (
    <div className="text-dark w-full flex flex-col justify-center items-center ">
      <div className="w-full h-full overflow-hidden flex justify-center items-center">
        <img
          src="static/resources/Contact.jpg"
          className=" min-w-[1000px] w-full min-h-[200px]"
          alt="Description"
        />
        <div className="sm:p-0 text-light text-lg md:text-xl lg:text-2xl absolute max-w-xl flex flex-col justify-center items-center">
          <p className="text-2xl md:text-3xl lg:text-4xl">Contact</p>
        </div>
      </div>
      <div className="flex flex-col w-full items-center text-center mt-8 text-sm mb-8 lg:text-lg">
        <p className=" flex text-secondary text-2xl md:text-3xl lg:text-3xl font-bold mb-5">
          Novăcescu Adriana
        </p>
        <Phone />
        <Mail />
        <Location />
      </div>
      <Map />
    </div>
  );
};

export default Contact;
